import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  preloader: false,
  notifications: [],
  modal: null,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    showPreloader(state) {
      state.preloader = true;
    },
    hidePreloader(state) {
      state.preloader = false;
    },
    pushNotification(state, action) {
      const { type = 'info', message, ttl = 5000 } = action.payload;
      state.notifications.push({
        id: crypto.randomUUID(),
        type,
        message,
        ttl,
        createdAt: Date.now(),
      });
    },
    dismissNotification(state, action) {
      state.notifications = state.notifications.filter((n) => n.id !== action.payload);
    },
    openModal(state, action) {
      state.modal = action.payload;
    },
    closeModal(state) {
      state.modal = null;
    },
  },
});

export const {
  showPreloader,
  hidePreloader,
  pushNotification,
  dismissNotification,
  openModal,
  closeModal,
} = uiSlice.actions;

export default uiSlice.reducer;
